<template>
  <div>
    <alert-error :error="error" />

    <v-toolbar>
      <v-toolbar-title
        >{{ $t('ITEM.ADD') }} {{ $t('NOTIFICATIONS.ITEM') }}</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="$router.go(-1)">
        {{ $t('BUTTON.BACK') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <v-form ref="form" v-model="valid" lazy-validation>
        <item-build v-if="localItem" v-model="localItem" />

        <v-container grid-list-md text-md-right fluid fill-height>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            :disabled="!(clickableSave && valid)"
            :loading="loading"
            @click.prevent="push"
          >
            {{ $t('BUTTON.SAVE') }}
          </v-btn>
        </v-container>
      </v-form>
    </v-sheet>
  </div>
</template>

<script>
import { Notification } from '@/modules/notifications/Notification';

export default {
  name: 'NotificationCreatePage',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    ItemBuild: () =>
      import('@/modules/notifications/components/NotificationBuild.vue')
  },

  data: () => ({
    localItem: null,
    error: null,
    valid: false,
    languages: null,
    clickableSave: false
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }

    // clickableSave() {
    //   return (
    //     this.localItem &&
    //     this.localItem.recipients &&
    //     this.localItem.recipients.length
    //   );
    // }
  },

  watch: {
    localItem: {
      deep: true,
      handler: 'getClickabilitySave'
    }
  },

  created() {
    this.helperItem = new Notification();

    this.$store
      .dispatch('localization/retrieveLanguages')
      .then(response => {
        this.languages = response.data;
        this.localItem = this.helperItem.initFrontendNotification();
      })
      .catch(error => {
        this.error = error.response;
      });
  },

  methods: {
    push() {
      if (
        this.helperItem.validateBeforeRequest(this.localItem, this.languages) &&
        this.$refs.form.validate()
      ) {
        let url = '/notifications';

        let translations = this.getTranslationsArray(
          this.localItem.generalInformation.translations
        );

        this.$store
          .dispatch('notification/storeOrUpdate', {
            url: url,
            data: this.localItem,
            translations: translations
          })
          .then(() => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$store.commit('loading', false);
            this.$router.push({ name: 'notifications' });
          })
          .catch(error => {
            this.$store.commit('loading', false);
            this.error = error.response;
          });
      }
    },

    getClickabilitySave() {
      this.clickableSave = this.helperItem.getClickabilitySave(this.localItem);
    },

    getTranslationsArray(translationsObject) {
      let translations = [];

      this.languages.forEach(language => {
        if (
          translationsObject[language.locale + 'Title'] &&
          translationsObject[language.locale + 'MainInformation']
        ) {
          translations.push({
            language_id: language.id,
            name: translationsObject[language.locale + 'Title'],
            description: translationsObject[language.locale + 'MainInformation']
          });
        }
      });

      return translations;
    }
  }
};
</script>
